const GEOARROW_ENCODINGS = ['geoarrow.multipolygon', 'geoarrow.polygon', 'geoarrow.multilinestring', 'geoarrow.linestring', 'geoarrow.multipoint', 'geoarrow.point', 'geoarrow.wkb', 'geoarrow.wkt'];
const GEOARROW_COLUMN_METADATA_ENCODING = 'ARROW:extension:name';
const GEOARROW_COLUMN_METADATA_METADATA = 'ARROW:extension:metadata';
export function getGeometryColumnsFromSchema(schema) {
  const geometryColumns = {};
  for (const field of schema.fields) {
    const metadata = getGeometryMetadataForField(field);
    if (metadata) {
      geometryColumns[field.name] = metadata;
    }
  }
  return geometryColumns;
}
export function getGeometryMetadataForField(field) {
  var _field$metadata, _field$metadata2;
  let metadata = null;
  let geoEncoding = (_field$metadata = field.metadata) === null || _field$metadata === void 0 ? void 0 : _field$metadata[GEOARROW_COLUMN_METADATA_ENCODING];
  if (geoEncoding) {
    geoEncoding = geoEncoding.toLowerCase();
    if (geoEncoding === 'wkb') {
      geoEncoding = 'geoarrow.wkb';
    }
    if (geoEncoding === 'wkt') {
      geoEncoding = 'geoarrow.wkt';
    }
    if (!GEOARROW_ENCODINGS.includes(geoEncoding)) {
      console.warn(`Invalid GeoArrow encoding: ${geoEncoding}`);
    } else {
      metadata = metadata || {};
      metadata.encoding = geoEncoding;
    }
  }
  const columnMetadata = (_field$metadata2 = field.metadata) === null || _field$metadata2 === void 0 ? void 0 : _field$metadata2[GEOARROW_COLUMN_METADATA_METADATA];
  if (columnMetadata) {
    try {
      metadata = JSON.parse(columnMetadata);
    } catch (error) {
      console.warn('Failed to parse GeoArrow metadata', error);
    }
  }
  return metadata || null;
}
//# sourceMappingURL=geoarrow-metadata.js.map